import angular from 'angular'
import taxClass from './taxClass'
import taxpayerSetting from './taxpayerSetting'
import vehicleInfo from './vehicleInfo'
import ticketedPoint from './ticketedPoint'
import taxControl from './taxControl'
import taxDisk from './taxDisk'
import projectInfo from './projectInfo'
import taxAccount from './taxAccount'

export default angular.module('app.system.basedata', [taxClass, taxpayerSetting, vehicleInfo, ticketedPoint, taxControl, taxDisk, projectInfo, taxAccount])
    .config(['$stateProvider', function config ($stateProvider) {
        $stateProvider.state('system.basedata', {
            abstract: true,
            url: '/basedata',
            template: '<div ui-view></div>',
            title: '系统基础数据',
        })
    }]).name



// WEBPACK FOOTER //
// ./src/app/system/basedata/index.js